import XLSX from 'xlsx';
import { api } from './backend/api';

var auto = false;
// Prevent default behavior of the dropped file.
// Prevention in both dragOverHandler and dropHandler are needed.
export function dragOverHandler(ev) {
  ev.preventDefault();
}

export function handleDrop(e, callback) {
  e.stopPropagation();
  e.preventDefault();

  var files = e.dataTransfer.files, f = files[0];

  let images = {};

  if(files[0].type == 'image/png' || files[0].type == 'image/jpg' || files[0].type  == 'image/jpeg' || files[0].type  == 'image/gif') {

    let imagePosition = ['imgTopRight', 'imgBottomLeft', 'imgBottomRight'];

    function setupReader (file, useCallback) {

      var reader = new FileReader();

      reader.addEventListener('load', function () {
        if ( /\.(jpe?g|png|gif)$/i.test(file.name) ) {
          let arrayedName = file.name.split('-');
          let histolitt_v2 = arrayedName[0];
          let position = arrayedName[1].split('.')[0];

          if(images[histolitt_v2] == undefined) {
            images[histolitt_v2] = {};
          }

          images[histolitt_v2][imagePosition[position]] = this.result;
          if(useCallback)
            callback(images);
        }
      }, false )

      reader.readAsDataURL(file);
      
    }

   /* if(files) {
      [].forEach.call(files, setupReader);
      //callback(images);
    }*/
    for(let i = 0; i < files.length; i++) {
      setupReader(files[i], (i + 1 == files.length));
    }
  }
  else {
    var reader = new FileReader();
    reader.onload = function(e) {
      var data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, {type: 'array'});
      console.log("workbook", workbook)
      var sheetNames = workbook.SheetNames;
      var sheets = workbook.Sheets;
      /*for(var i = 0; i < workbook.Props.Worksheets; i++) {
        sheetNames.push(workbook.SheetNames[i]);
        sheets.push(XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[i]], { header: 1, blankrows: false }))
      }*/
      console.log({SheetNames: sheetNames, Sheets: sheets})
      callback( { workbook: {SheetNames: sheetNames, Sheets: sheets}} /*{ workbook }*/)
    };
    reader.readAsArrayBuffer(f);
  }

  

      /*
  return new Promise((resolve, rejet) => {
    var files = e.dataTransfer.files, f = files[0];
    console.log(e.target)
    console.log(files)
    
    console.log(files[0].type);
    if(files[0].type == 'image/png' || files[0].type == 'image/jpg'){
      let imagePosition = ['imgTopRight', 'imgBottomLeft', 'imgBottomRight'];
      let images = [];
      for(let i = 0; i < files.length; i++) {
        let arrayedName = files[i].name.split('-');
        let arrayedPosition = arrayedName[1].split('.');

        var reader = new FileReader();
        reader.onload = function(e) {
          let obj = {
            histolitt: arrayedName[0],
            position: arrayedPosition[0],
            src: e.target.result
          };

          images.push(obj);
        }
        reader.readAsDataURL(files[i]);
        if(i + 1 == files.length) {
          resolve({images});
        }
      }
      console.log('images : ', images);
    } else {
      var reader = new FileReader();
      reader.onload = function(e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, {type: 'array'});
        console.log(workbook)
        var sheetNames = [];
        var sheets = [];
        for(var i = 0; i < workbook.Props.Worksheets; i++) {
          sheetNames.push(workbook.SheetNames[i]);
          sheets.push(XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[i]], { header: 1, blankrows: false }))
        }
        resolve( {
          workbook
        });
      };
      reader.readAsArrayBuffer(f);
    }
  });*/
}

// Get the file and hand it over to the parser.
export function dropHandler(ev) {
  return new Promise((resolve, reject) => {
    ev.preventDefault();
    if(ev.dataTransfer.items) {
      var array = [];
      if(ev.dataTransfer.items.length == 1)
        auto = true;
      else
        auto = false;
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        if (ev.dataTransfer.items[i].kind === 'file') {
          console.log(ev.dataTransfer.items[i])
          array.push(ev.dataTransfer.items[i].getAsFile());
        }
      }
      staging(resolve, array);
    } else {
      document.getElementById("code").innerHTML = "Error while getting file";
    } 
  });
}

function staging(resolve, array) {
  array.forEach(file => {
    var reader = new FileReader();
    reader.onload = (function(reader) {
      return function(e) {
        var content = reader.result;
        splitFile(resolve, file, content)
      }
    })(reader);
    reader.readAsText(file, 'UTF-8');
  });
}

function splitFile(resolve, file, content) {
  if(content == undefined){
    console.log('Loading')
  }
  else {
    content = content.replace(/\r/gi, '');
    let header = content.slice(0, content.indexOf('\n'));
    header = header.split('\t');
    let contentArray = content.split('\n');
    contentArray.shift();
    console.log('Columns\' titles :' , header);
    
    let arrayIlot = [];
    for(var i = 0; i < contentArray.length; i++) {
      let ilot = {};
      let tmp = contentArray[i].split('\t');
      for(var ii = 0; ii < header.length; ii++) {
        ilot[header[ii]] = tmp[ii];
      }
      arrayIlot.push(ilot);
    }
    
    resolve(
      {
        header, 
        entries: arrayIlot
      }
    );
  }
}